module.exports = import("//unpkg.com/@cortex-js/compute-engine?module");;